<template>
	<div>
		<v-card>
			<v-card-title class="py-2 primary">
				<span class="tertiary--text">
					{{ action == 'store' ? 'Aggiungi Contratto di Servizio' : (action == 'edit' ? 'Modifica Contratto di Servizio' : 'Visualizza Contratto di Servizio') }}
				</span>
			</v-card-title>
			<v-card-text class="pt-6">
				<v-form ref="contrattoDiServizioForm">
					
					<v-row>
						<v-col v-if="bando.id < 26" cols="6">
							<v-text-field
								:value="contrattoDiServizio.importo_acconto"
								@input="contrattoDiServizio.importo_acconto = $event !== '' ? $event : null"
								label="Imponibile Acconto da Fatturare Esiti Provvisori"
								outlined
								dense
								hide-details
								readonly
								:disabled="isLoading"
							></v-text-field>
						</v-col>
						
						<v-col cols="6">
							<v-text-field
								:value="contrattoDiServizio.importo_saldo"
								@input="contrattoDiServizio.importo_saldo = $event !== '' ? $event : null"
								label="Imponibile da Fatturare Esiti Provvisori"
								outlined
								dense
								hide-details
								readonly
								:disabled="isLoading"
							></v-text-field>
						</v-col>
					</v-row>
					
					<v-row v-if="bando.id < 26">
						<v-col>
							<template v-if="(action == 'store' || action == 'edit')">
								<v-file-input
									v-model="files.fattura_acconto"
									label="Fattura Acconto Esiti Provvisori"
									hide-details
									outlined
									dense
									clearable
									accept=".pdf"
									truncate-length="120"
									@change="setChanged(files.fattura_acconto)"
									@click:clear="contrattoDiServizio.path_fattura_acconto = null"
									:loading="isLoadingFatturaAcconto"
									:disabled="isLoading"
								>
									<template
										v-slot:append
									>
										<template v-if="contrattoDiServizio.path_fattura_acconto !== null && !isLoadingFatturaAcconto">
											<v-progress-circular
												v-if="downloadingFatturaAcconto"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_acconto, 'fattura_acconto')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<v-icon
											v-if="files.fattura_acconto !== null"
											class="ml-3"
											@click="viewFileInBrowser(files.fattura_acconto)"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-file-input>
							</template>
							
							<template v-else-if="action == 'show'">
								<v-text-field
									:value="getFileNameFromPath(contrattoDiServizio.path_fattura_acconto)"
									label="Fattura Acconto Esiti Provvisori"
									hide-details
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="contrattoDiServizio.path_fattura_acconto !== null"
									>
										<template>
											<v-progress-circular
												v-if="downloadingFatturaAcconto"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_acconto, 'fattura_acconto')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<template>
											<v-progress-circular
												v-if="isGettingFile.fattura_acconto"
												size="24"
												width="3"
												color="primary"
												indeterminate
												class="ml-3"
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="getFileAndViewInBrowser(contrattoDiServizio.path_fattura_acconto, 'fattura_acconto')"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</template>
								</v-text-field>
							</template>
						</v-col>
					</v-row>
					
					<v-row>
						<v-col>
							<template v-if="action == 'store' || action == 'edit' ">
								<v-file-input
									v-model="files.fattura_saldo"
									label="Fattura Esiti Provvisori"
									hide-details
									outlined
									dense
									clearable
									accept=".pdf"
									truncate-length="120"
									@change="setChanged(files.fattura_saldo)"
									@click:clear="contrattoDiServizio.path_fattura_saldo = null"
									:loading="isLoadingFatturaSaldo"
									:disabled="isLoading"
								>
									<template
										v-slot:append
									>
										<template v-if="contrattoDiServizio.path_fattura_saldo !== null && !isLoadingFatturaSaldo">
											<v-progress-circular
												v-if="downloadingFatturaSaldo"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_saldo, 'fattura_saldo')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<v-icon
											v-if="files.fattura_saldo !== null"
											class="ml-3"
											@click="viewFileInBrowser(files.fattura_saldo)"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-file-input>
							</template>
							
							<template v-else-if="action == 'show'">
								<v-text-field
									:value="getFileNameFromPath(contrattoDiServizio.path_fattura_saldo)"
									label="Fattura Esiti Provvisori"
									hide-details
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="contrattoDiServizio.path_fattura_saldo !== null"
									>
										<template>
											<v-progress-circular
												v-if="downloadingFatturaSaldo"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_saldo, 'fattura_saldo')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<template>
											<v-progress-circular
												v-if="isGettingFile.fattura_saldo"
												size="24"
												width="3"
												color="primary"
												indeterminate
												class="ml-3"
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="getFileAndViewInBrowser(contrattoDiServizio.path_fattura_saldo, 'fattura_saldo')"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</template>
								</v-text-field>
							</template>
						</v-col>
					</v-row>
					
					<v-row>
						<v-col v-if="bando.id < 26" cols="6">
							<v-text-field
								:value="contrattoDiServizio.importo_acconto_esiti_definitivi"
								@input="contrattoDiServizio.importo_acconto_esiti_definitivi = $event !== '' ? $event : null"
								label="Imponibile Acconto da Fatturare Esiti Definitivi"
								outlined
								dense
								hide-details
								readonly
								:disabled="isLoading"
							></v-text-field>
						</v-col>
						
						<v-col cols="6">
							<v-text-field
								:value="contrattoDiServizio.importo_saldo_esiti_definitivi"
								@input="contrattoDiServizio.importo_saldo_esiti_definitivi = $event !== '' ? $event : null"
								label="Imponibile da Fatturare Esiti Definitivi"
								outlined
								dense
								hide-details
								readonly
								:disabled="isLoading"
							></v-text-field>
						</v-col>
					</v-row>
					
					<v-row v-if="bando.id < 26">
						<v-col>
							<template v-if="(action == 'store' || action == 'edit')">
								<v-file-input
									v-model="files.fattura_acconto_esiti_definitivi"
									label="Fattura Acconto Esiti Definitivi"
									hide-details
									outlined
									dense
									clearable
									accept=".pdf"
									truncate-length="120"
									@change="setChanged(files.fattura_acconto_esiti_definitivi)"
									@click:clear="contrattoDiServizio.path_fattura_acconto_esiti_definitivi = null"
									:loading="isLoadingFatturaAccontoEsitiDefinitivi"
									:disabled="isLoading"
								>
									<template
										v-slot:append
									>
										<template v-if="contrattoDiServizio.path_fattura_acconto_esiti_definitivi !== null && !isLoadingFatturaAccontoEsitiDefinitivi">
											<v-progress-circular
												v-if="downloadingFatturaAccontoEsitiDefinitivi"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_acconto_esiti_definitivi, 'fattura_acconto_esiti_definitivi')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<v-icon
											v-if="files.fattura_acconto_esiti_definitivi !== null"
											class="ml-3"
											@click="viewFileInBrowser(files.fattura_acconto_esiti_definitivi)"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-file-input>
							</template>
							
							<template v-else-if="action == 'show'">
								<v-text-field
									:value="getFileNameFromPath(contrattoDiServizio.path_fattura_acconto_esiti_definitivi)"
									label="Fattura Acconto Esiti Definitivi"
									hide-details
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="contrattoDiServizio.path_fattura_acconto_esiti_definitivi !== null"
									>
										<template>
											<v-progress-circular
												v-if="downloadingFatturaAccontoEsitiDefinitivi"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_acconto_esiti_definitivi, 'fattura_acconto_esiti_definitivi')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<template>
											<v-progress-circular
												v-if="isGettingFile.fattura_acconto_esiti_definitivi"
												size="24"
												width="3"
												color="primary"
												indeterminate
												class="ml-3"
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="getFileAndViewInBrowser(contrattoDiServizio.path_fattura_acconto_esiti_definitivi, 'fattura_acconto_esiti_definitivi')"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</template>
								</v-text-field>
							</template>
						</v-col>
					</v-row>
					
					<v-row>
						<v-col>
							<template v-if="(action == 'store' || action == 'edit')">
								<v-file-input
									v-model="files.fattura_saldo_esiti_definitivi"
									label="Fattura Esiti Definitivi"
									hide-details
									outlined
									dense
									clearable
									accept=".pdf"
									truncate-length="120"
									@change="setChanged(files.fattura_saldo_esiti_definitivi)"
									@click:clear="contrattoDiServizio.path_fattura_saldo_esiti_definitivi = null"
									:loading="isLoadingFatturaSaldoEsitiDefinitivi"
									:disabled="isLoading"
								>
									<template
										v-slot:append
									>
										<template v-if="contrattoDiServizio.path_fattura_saldo_esiti_definitivi !== null && !isLoadingFatturaSaldoEsitiDefinitivi">
											<v-progress-circular
												v-if="downloadingFatturaSaldoEsitiDefinitivi"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_saldo_esiti_definitivi, 'fattura_saldo_esiti_definitivi')"
											>
												mdi-tray-arrow-down
											</v-icon>
											
											<v-icon
												v-if="files.fattura_saldo_esiti_definitivi !== null"
												class="ml-3"
												@click="viewFileInBrowser(files.fattura_saldo_esiti_definitivi)"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</template>
								</v-file-input>
							</template>
							
							<template v-else-if="action == 'show'">
								<v-text-field
									:value="getFileNameFromPath(contrattoDiServizio.path_fattura_saldo_esiti_definitivi)"
									label="Fattura Esiti Definitivi"
									hide-details
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="contrattoDiServizio.path_fattura_saldo_esiti_definitivi !== null"
									>
										<template>
											<v-progress-circular
												v-if="downloadingFatturaSaldoEsitiDefinitivi"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(contrattoDiServizio.path_fattura_saldo_esiti_definitivi, 'fattura_saldo_esiti_definitivi')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										
										<template>
											<v-progress-circular
												v-if="isGettingFile.fattura_saldo_esiti_definitivi"
												size="24"
												width="3"
												color="primary"
												indeterminate
												class="ml-3"
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="getFileAndViewInBrowser(contrattoDiServizio.path_fattura_saldo_esiti_definitivi, 'fattura_saldo_esiti_definitivi')"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</template>
								</v-text-field>
							</template>
						</v-col>
					</v-row>
					
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="tertiary"
					@click="close()"
					:disabled="isSaving"
					class="black--text"
				>
					{{ action == 'show' ? 'Chiudi' : 'Annulla'}}
				</v-btn>
				<v-btn
					v-if="action == 'store' || action == 'edit'"
					color="secondary"
					@click="action == 'store' ? store() : (action == 'edit' ? update() : null)"
					:loading="isSaving"
					:disabled="isLoading || isSaving"
				>
					Salva
				</v-btn>
			</v-card-actions>
		</v-card>
	
	</div>
</template>

<script>
import { eventBus } from "@/event-bus";
import {mapActions, mapGetters} from "vuex";
export default {
	props: ['value', 'action'],
	data() {
		return {
			contrattoDiServizio: {},
			
			files: {
				fattura_acconto: null,
				fattura_saldo: null,
				fattura_acconto_esiti_definitivi: null,
				fattura_saldo_esiti_definitivi: null
			},
			
			isLoadingFatturaAcconto: false,
			isLoadingFatturaAccontoEsitiDefinitivi: false,
			isLoadingFatturaSaldo: false,
			isLoadingFatturaSaldoEsitiDefinitivi: false,
			downloadingFatturaAcconto: false,
			downloadingFatturaAccontoEsitiDefinitivi: false,
			downloadingFatturaSaldo: false,
			downloadingFatturaSaldoEsitiDefinitivi: false,
			
			isSaving: false
		}
	},
	
	created() {
		this.contrattoDiServizio = Object.assign({}, this.value || this.praticaVoid.contratto_di_servizio);
		
		if (this.contrattoDiServizio.path_fattura_acconto !== null && this.action != 'show') {
			this.getFatturaAcconto();
		}
		
		if (this.contrattoDiServizio.path_fattura_acconto_esiti_definitivi !== null && this.action != 'show') {
			this.getFatturaAccontoEsitiDefinitivi();
		}
		
		if (this.contrattoDiServizio.path_fattura_saldo !== null && this.action != 'show') {
			this.getFatturaSaldo();
		}
		
		if (this.contrattoDiServizio.path_fattura_saldo_esiti_definitivi !== null && this.action != 'show') {
			this.getFatturaSaldoEsitiDefinitivi();
		}
	},
	
	computed: {
		...mapGetters({
			bando: 'shared/bando'
		}),
		isLoading() {
			return this.isLoadingFatturaAcconto
				|| this.isLoadingFatturaAccontoEsitiDefinitivi
				|| this.isLoadingFatturaSaldo
				|| this.isLoadingFatturaSaldoEsitiDefinitivi;
		}
	},
	
	methods: {
		...mapActions({
			showSnackbar: 'systemSnackbar/show'
		}),
		store() {
			// if (!this.$refs.contrattoDiServizioForm.validate()) return
			// this.isSaving = true;
			// let formData = new FormData();
			// for (let key in this.files) {
			// 	formData.append(`files[${key}]`, this.files[key]);
			// }
			// formData.append('contratto_di_servizio', JSON.stringify(this.contrattoDiServizio));
			// axios.post('/api/contratti-di-servizio', formData, {
			// 	headers: { 'Content-Type': 'multipart/form-data' }
			// })
			// 	.then(response => {
			// 		this.showSnackbar({
			// 			color: 'success',
			// 			message: this.generalSuccessMessage
			// 		})
			// 		this.$emit('close');
			// 		this.$emit('reload-contratti-di-servizio');
			// 	})
			// 	.finally(() => {
			// 		this.isSaving = false;
			// 	})
		},
		update() {
			if (!this.$refs.contrattoDiServizioForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();
			for (let key in this.files) {
				if (this.files[key] !== null) {
					if (this.files[key].hasOwnProperty('changed')) {
						if (this.files[key].changed) formData.append(`files[${key}]`, this.files[key]);
					}
				}
			}
			formData.append('contratto_di_servizio', JSON.stringify(this.contrattoDiServizio));
			axios.patch(`/api/contratti-di-servizio/${this.contrattoDiServizio.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('close');
					this.$emit('reload-contratti-di-servizio');
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		async getFatturaAcconto() {
			this.isLoadingFatturaAcconto = true;
			this.files.fattura_acconto = await this.getFile(this.contrattoDiServizio.path_fattura_acconto);
			this.files.fattura_acconto.changed = false;
			this.isLoadingFatturaAcconto = false;
		},
		async getFatturaAccontoEsitiDefinitivi() {
			this.isLoadingFatturaAccontoEsitiDefinitivi = true;
			this.files.fattura_acconto_esiti_definitivi = await this.getFile(this.contrattoDiServizio.path_fattura_acconto_esiti_definitivi);
			this.files.fattura_acconto_esiti_definitivi.changed = false;
			this.isLoadingFatturaAccontoEsitiDefinitivi = false;
		},
		async getFatturaSaldo() {
			this.isLoadingFatturaSaldo = true;
			this.files.fattura_saldo = await this.getFile(this.contrattoDiServizio.path_fattura_saldo);
			this.files.fattura_saldo.changed = false;
			this.isLoadingFatturaSaldo = false;
		},
		async getFatturaSaldoEsitiDefinitivi() {
			this.isLoadingFatturaSaldoEsitiDefinitivi = true;
			this.files.fattura_saldo_esiti_definitivi = await this.getFile(this.contrattoDiServizio.path_fattura_saldo_esiti_definitivi);
			this.files.fattura_saldo_esiti_definitivi.changed = false;
			this.isLoadingFatturaSaldoEsitiDefinitivi = false;
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'fattura_acconto') this.downloadingFatturaAcconto = true;
			else if (key == 'fattura_acconto_esiti_definitivi') this.isLoadingFatturaAccontoEsitiDefinitivi = true;
			else if (key == 'fattura_saldo') this.downloadingFatturaSaldo = true;
			else if (key == 'fattura_saldo_esiti_definitivi') this.downloadingFatturaSaldoEsitiDefinitivi = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'fattura_acconto') this.downloadingFatturaAcconto = false;
					else if (key == 'fattura_acconto_esiti_definitivi') this.isLoadingFatturaAccontoEsitiDefinitivi = false;
					else if (key == 'fattura_saldo') this.downloadingFatturaSaldo = false;
					else if (key == 'fattura_saldo_esiti_definitivi') this.downloadingFatturaSaldoEsitiDefinitivi = false;
				})
		},
	}
}
</script>

<style scoped>

</style>